exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".financialAidContainer_3hGvB {\n    font-size: 16px;\n}\n\n.financialAidContainer_3hGvB > ul {\n    list-style-type: none;\n}\n\n.financialAidContainer_3hGvB > ul > li {\n    padding: 10px 0;\n}\n\n.officer_2xXQ5 {\n    text-align: center;\n}\n\n.divition_1U4VG {\n    margin: 10px 0;\n    border-top: 3px solid #1e1e1e;\n}\n\n.infoCavt_2fOIq {\n    text-align: center;\n    font-size: 16px;\n}\n\n.submitBtn_jwcoN {\n    text-align: center;\n}\n\n.gapSection5_dioC4 {\n    height: 110px;\n}\n", ""]);

// exports
exports.locals = {
	"financialAidContainer": "financialAidContainer_3hGvB",
	"officer": "officer_2xXQ5",
	"divition": "divition_1U4VG",
	"infoCavt": "infoCavt_2fOIq",
	"submitBtn": "submitBtn_jwcoN",
	"gapSection5": "gapSection5_dioC4"
};